import Phaser from 'phaser'
import GamePlay from './scene/GamePlay.js'
import Preload from './scene/GamePreload.js'
import GameMenu from './scene/GameMenu.js'
import eventBus from "@/plugins/event-bus";

/*
let game
window.onload = function() {
let config = {
    type: Phaser.AUTO,
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        parent: "game",
        width:720,
        height:1280,
    },
    backgroundColor: '#000000',

    scene: [Preload,GameMenu,GamePlay]
}
game = new Phaser.Game(config);

}
 */


function launch(containerId) {
    let height = 1280;
    let width = 720;
    const heightW = window.innerHeight;
    const widthW = window.innerWidth;


    //console.log(heightW)
    if (heightW < 600) {
        eventBus.emit('isDesktop', true);
    }


    let game;
    window.onload = function() {

    };

    return new Phaser.Game({
        type: Phaser.AUTO,
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: containerId,
            width: heightW < 700 ? widthW * 2 : 720,
            height:heightW < 700 ? heightW*2 : 1280, //,
        },
        backgroundColor: '#06091b',
        scene: [Preload,GameMenu,GamePlay]
    })
}

export default launch
export { launch }
